import axios from "@/axios.js";
export default {
  async updateAlexpreferences(_, payload) {
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${this.state.auth.accessToken}`, };
    const res = await axios.post(
      `https://api-core-gateway.getboarded.com/alex/digest?gtbrddUserId=${this.state.auth.user._id}`,
      payload,
      { headers }
    );
    return res.data.data;
  },

  async getALexDigest(_, token) {
    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}`, };
    const res = await axios.get(`https://api-core-gateway.getboarded.com/alex/digest?gtbrddUserId=${this.state.auth.user._id}`, {
      headers,
    });
    return res.data.data;
  },
};
